<template>
    <div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">同学关系及师生关系测评 ></span>
			<span>开始测试</span>
		</div>
		<relation-a v-show="tabId==1"></relation-a>
		<relation-b v-show="tabId==2"></relation-b>
    </div>
</template>

<script>
import relationA from './relationa.vue';
import relationB from './relationb.vue';
export default {
	components: {
		relationA,
		relationB
	},
    data() {
        return {
			tabId: 1
        };
    },
    methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 返回上一级
		goBack() {
			this.$router.go(-1);
		}
    }
};
</script>

<style scoped>
</style>
